import styled from 'styled-components';

export const FormContentWrapper = styled.div<{ isModal?: boolean }>`
  ${({ isModal }) => !isModal && 'display: flex'};

  & > div {
    margin-right: 48px;
  }

  .ant-form-item {
    width: 288px;
  }
`;

export const DeleteContainer = styled.div<{ isIcon: boolean }>`
  display: flex;

  ${({ isIcon }) =>
    isIcon &&
    `

    & > div:last-child {
        margin-left: 18px;
        margin-top: 7px;
        cursor: pointer;
    }
  `}
`;

interface IFormListProps {
  isIcon: boolean;
  isCreate: boolean;
  isModal?: boolean;
}

export const FormListContentWrapper = styled.div<IFormListProps>`
  width: 100%;
  & > div:last-child {
    .ant-btn {
      margin-right: ${({ isIcon }) => (isIcon ? '40px' : 0)};
      margin-left: auto;
      padding: 0;
    }
  }

  ${({ isModal, isCreate }) =>
    !isModal &&
    `
      overflow-x: auto;
      & > div:first-child {
        display: inline-flex;
        flex-direction: column;
        flex-wrap: wrap;
        max-height: ${isCreate ? '370px' : '450px'};
      }

      & > div > div {
        margin-right: 48px;
      }
  `}
`;

export const UploadFormItemWrapper = styled.div`
  .ant-btn {
    width: 100%;
    justify-content: center;
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;

  & > div:first-child {
    margin-right: 10px;
  }

  & > div:last-child {
    cursor: pointer;
    transition: none;
    :hover {
      color: ${({ theme }) => theme.colors.primary.blue};
    }
  }
`;
